import { useEffect, useState } from "react";
import DropDownInput from "../../../helperComponents/DropDownInput";
import { serverLine } from "../../../../controllers/network/serverLine";

export default function ZoneDropDownInput({
  onChange,
  label,
  value,
  style,
  autoSetInitialValue,
}) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    load();
  }, []);

  if (!items) return null;

  let options = items.map((item) => {
    return { value: item._id, label: item.name };
  });

  return (
    <DropDownInput
      style={style}
      value={value}
      label={label}
      onChange={onChange}
      options={options}
    />
  );

  function load() {
    serverLine.get("/zones").then((data) => {
      setItems(data.list);

      if (autoSetInitialValue && data.list.length) {
        onChange(data.list[0]._id);
        // console.log("data.list[0]._id", data.list[0]._id);
      }
    });
  }
}
